import { FC, ComponentType, ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import theme from 'styles/theme'

interface HelpdeskEmptyStateProps {
  Icon: ComponentType<any>
  title: string
  subtitle?: string
  action?: ReactNode
}

// Empty state card styled per the "Panel Klienta 3.0" design.
const HelpdeskEmptyState: FC<HelpdeskEmptyStateProps> = ({ Icon, title, subtitle, action }) => (
  <Box
    sx={{
      backgroundColor: '#fff',
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.06)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: { xs: '48px 24px', md: '84px 40px 80px' }
    }}>
    <Box
      sx={{
        width: { xs: '72px', md: '100px' },
        height: { xs: '72px', md: '100px' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: alpha(theme.r4r.navy, 0.06)
      }}>
      <Icon sx={{ color: theme.r4r.navy, fontSize: { xs: '32px', md: '44px' } }} />
    </Box>
    <Typography
      sx={{
        fontSize: { xs: '17px', md: '20px' },
        fontWeight: 800,
        color: theme.r4r.navy,
        mt: '28px'
      }}>
      {title}
    </Typography>
    {!!subtitle && (
      <Typography
        sx={{
          fontSize: '14px',
          color: theme.r4r.grey,
          lineHeight: '22.4px',
          maxWidth: '400px',
          mt: '10px'
        }}>
        {subtitle}
      </Typography>
    )}
    {!!action && <Box sx={{ mt: '24px' }}>{action}</Box>}
  </Box>
)

export default HelpdeskEmptyState
